import React, { useId, useMemo } from 'react';
import { AppIcon } from '../../../../components/icons/AppIcon';
import { ChatTagSelector } from './ChatTagSelector';
import { ChatUserSelector } from './ChatUserSelector';
import { useTags } from '../../../settings/tags/hooks/useTags';

interface User {
    id: string;
    name: string;
}

interface ContactPanelConversationInfoProps {
    isOpen: boolean;
    onToggle: () => void;
    users: User[];
    selectedUserId: string | null;
    onUserChange: (userId: string | null) => void;
    selectedTagIds: string[];
    onTagsChange: (tagIds: string[]) => void;
}

export const ContactPanelConversationInfo: React.FC<ContactPanelConversationInfoProps> = ({
    isOpen,
    onToggle,
    users,
    selectedUserId,
    onUserChange,
    selectedTagIds,
    onTagsChange
}) => {
    const { tags } = useTags();
    const panelId = useId();

    const validTagCount = useMemo(() => {
        return selectedTagIds.filter(id => tags.some(tag => tag.id === id)).length;
    }, [selectedTagIds, tags]);

    return (
        <section>
            <button
                type="button"
                onClick={onToggle}
                className="flex min-h-11 w-full items-center justify-between px-3 py-2"
                aria-expanded={isOpen}
                aria-controls={panelId}
            >
                <div className="flex items-center gap-2 chat-section-heading">
                    <span>Informação da conversa</span>
                    {validTagCount > 0 && (
                        <span className="chat-count rounded-full border border-border bg-surface-subtle px-1.5 py-0 leading-5 text-muted">
                            {validTagCount}
                        </span>
                    )}
                </div>
                <AppIcon
                    name="chevron-down"
                    className={`chat-accordion-chevron ${isOpen ? '' : 'chat-accordion-chevron--closed'}`}
                    aria-hidden="true"
                />
            </button>

            {isOpen && (
                <div id={panelId} className="bg-card px-3 pb-3">
                    <div className="space-y-4 rounded-lg border border-border bg-surface p-3">
                        <fieldset className="m-0 min-w-0 space-y-2 border-0 p-0">
                            <legend className="text-label mb-1.5 px-0">Responsável</legend>
                            <ChatUserSelector
                                users={users}
                                selectedUserId={selectedUserId}
                                onUserChange={onUserChange}
                            />
                        </fieldset>
                        <fieldset className="m-0 min-w-0 space-y-2 border-0 p-0">
                            <legend className="text-label mb-1.5 px-0">Tags da conversa</legend>
                            <ChatTagSelector
                                selectedTagIds={selectedTagIds}
                                onTagsChange={onTagsChange}
                            />
                        </fieldset>
                    </div>
                </div>
            )}
        </section>
    );
};
